<template>
  <div v-if="data !== null">
    <div>
      <div class="filters">
        <div class="subject-toggle-filters">
          <button
              v-for="tag in subjectTags"
              :key="tag"
              class="button-secondary subject-toggle-btn"
              :class="{ active: selectedSubjectTags.includes(tag) }"
              @click="toggleSubjectTag(tag)"
              type="button"
              :aria-pressed="selectedSubjectTags.includes(tag) ? 'true' : 'false'"
          >
            {{ tag }}
          </button>
        </div>
      </div>
    </div>
    
    <!--    Desktop   -->
    <div class="count-clean-wrapper">
      <ListCountResults
          :total-filtered-items="data.totalFilteredItems"
          :total-items="data.totalItems"
      />

      <span v-if="anyFilterSet" class="line"> | </span>
      
      <ListCleanFilters v-if="anyFilterSet"
          @clear-filters="clearFilters"
      />
    </div>
    
    <div class="items-wrapper">
      <a v-for="item in data.items" :href="item.link">
        <PositionHoverButton class="case-list-hover" />
        
        <figure v-if="item.image !== null" class="img-wrapper">
          <img :src="item.image" :alt="item.header"/>
          <figcaption v-if="item.subject !== ''" class="style-caption">{{ item.subject }}</figcaption>
        </figure>

        <div class="text-wrapper">
          <span class="style-label-underscore">{{ item.label }}</span>
          <h3 class="style-h5 item-heading">{{ item.header }}</h3>
          <div class="related-link">
            <svg class="icon related-icon-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 viewBox="0 0 16 16" fill="none">
              <path
                  d="M3.5 8.75L9.625 8.75L7.4375 10.9375L8.5 12L12.5 8L8.5 4L7.4375 5.0625L9.625 7.25L3.5 7.25L3.5 8.75Z"
                  fill="currentColor"/>
            </svg>
          </div>
        </div>
      </a>
    </div>

    <Pagination
        :totalPages="totalPages"
        :currentPage="currentPage"
        @update:currentPage="val => currentPage = val"
    />
  </div>
  <!--  implement loading-->
</template>

<script setup>
import {ref, watch, onMounted} from 'vue'
import Pagination from "../components/pagination.vue";

import ListCleanFilters from "../components/listCleanFilters.vue";
import ListCountResults from "../components/listCountResults.vue";
import PositionHoverButton from "../components/positionHoverButton.vue";

const data = ref(null)

const currentPage = ref(1)
const totalPages = ref(1)
const selectedSubjectTags = ref([])

const subjectTags = ref([])

const anyFilterSet = ref(false)

onMounted(async () => {
  await fetchData()

  subjectTags.value = data.value.subjectTags;
})

const fetchData = async () => {
  const subjectTagQuery = selectedSubjectTags.value
      .map(tag => `&subject=${tag}`)
      .join('');

  const url = `/umbraco/api/caselist/listcases?page=${currentPage.value}&pageSize=8${subjectTagQuery}`;
  const request = await fetch(url);
  
  data.value = await request.json();

  totalPages.value = data.value.totalPages;
}

function toggleSubjectTag(tag) {
  const index = selectedSubjectTags.value.indexOf(tag)
  if (index === -1) {
    selectedSubjectTags.value = [...selectedSubjectTags.value, tag]
  } else {
    selectedSubjectTags.value = selectedSubjectTags.value.filter(t => t !== tag)
  }
}

function clearFilters() {
  selectedSubjectTags.value = []
  currentPage.value = 1
}

watch(selectedSubjectTags, async () => {
  anyFilterSet.value =
      selectedSubjectTags.value.length > 0;

  currentPage.value = 1;
  await fetchData()
});

watch([currentPage], async () => {
    await fetchData()
});

watch(currentPage, async () => {
  const filterWrapper = document.querySelector('.filters-wrapper');
  if (filterWrapper) {
    const offsetTop = filterWrapper.getBoundingClientRect().top + window.scrollY - 180;
    window.scrollTo({top: offsetTop, behavior: 'smooth'});
  }
});

</script>
